import React from 'react'
import Router from 'next/router'
import styled from 'styled-components'
import Link from 'next/link'

import { Column } from '../Grid'
import { Text } from '../Text'
import { Button } from '../Button'

import { checkIsMobile } from '../../../utils/helpers'

const EmptyList = isLoggedIn => {
  const isMobile = !checkIsMobile(426)
  const label = isMobile
    ? 'Você ainda não salvou seus psicólogos favoritos'
    : 'Sua lista está vazia'
  return (
    <>
      <Text variant='bigger' marginTop={['90px', '48px']}>
        {label}
      </Text>
      <ColumnEmptyFavorites alignItems='center'>
        {!isLoggedIn ? (
          <>
            <Text variant='regular' width={['324px', '837px']}>
              Se você tem um benefício corporativo,
              <Link href='/entrar'>
                <TextLink>faça seu login</TextLink>
              </Link>
              para melhorar sua experiência e buscar psicólogos que atendam a sua empresa.
            </Text>
            <Button
              type='button'
              onClick={() => Router.push('/busca')}
              height='47px'
              width='204px'
              mt='27px'
              p={0}
            >
              Encontrar psicólogos
            </Button>
          </>
        ) : (
          <>
            <Text variant='regular' width={['324px', '837px']}>
              Não sabe como começar?
            </Text>
            <Text variant='regular' width={['324px', '837px']}>
              Use o Vittude Match, nossa ferramenta que usa inteligência artificial para sugerir o
              psicólogo ideal para você.
            </Text>
            <Button
              type='button'
              onClick={() => Router.push('/encontre-seu-psicologo')}
              height='47px'
              width='204px'
              mt='27px'
              p={0}
            >
              Encontrar psicólogos
            </Button>
          </>
        )}
      </ColumnEmptyFavorites>
    </>
  )
}

const ColumnEmptyFavorites = styled(Column)`
  background: url('/static/images/favorites.svg');
  width: 1141px;
  height: 658px;
  margin: 38px auto 158px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom;

  @media (max-width: 425px) {
    width: 356px;
    height: 410px;
    margin: 32px auto 107px;
  }

  @media (max-width: 320px) {
    width: 310px;
    height: 410px;
    background-position: bottom;
    background-repeat: no-repeat;
    margin: 32px auto 107px;
  }
`

const TextLink = styled.a`
  font-weight: bold;
  margin: 0 5px;
  color: #ff6e63;
  text-decoration: underline;

  &:hover {
    color: #ff6e63;
    text-decoration: underline;
  }
`

export { EmptyList }
